import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load();
const getFingerprint = async () => {
    const fp = await fpPromise;
    const result = await fp.get();
    return await result.visitorId; // stable device fingerprint
};
export default getFingerprint;
